
import { Fostplus } from "@/models/base/fostplus";
import { FostplusService } from "@/services/fostplus-service";
import Vue from "vue";
import AppProductTaxesEditFostplusEditItem from "./ProductTaxesEditFostplusEditItem.vue";

export default Vue.extend({
	data(){
		return {
			year: new Date().getFullYear(),
			taxes: [] as Fostplus[],
			toEditItem: null as null | Fostplus
		};
	},
	methods: {
		async increaseYear(){
			this.year++;
			await this.fetchTaxes();
		},
		async decreaseYear(){
			this.year--;
			await this.fetchTaxes();
		},
		async fetchTaxes(){
			this.taxes = await FostplusService.fetchFostplusItemsByYear(this.year);
		},
		editTax(tax:Fostplus){
			this.toEditItem = tax;
		},
		async deleteTax(tax:Fostplus){
			await FostplusService.deleteFostplusItem(tax.Code, tax.Year);
			await this.fetchTaxes();
		},
		addItem(){
			this.toEditItem = new Fostplus();
		}
	},
	async mounted(){
		await this.fetchTaxes();
	},
	components: {
		AppProductTaxesEditFostplusEditItem
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	}
});
